/*
 * Copyright (C) 2022 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EmbeddedViewRef,
  Input,
  OnDestroy,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { ResponsivePillContext, ResponsivePillDirective } from '../responsive-pill.directive';

/**
 * Temporary component for computation of responsive pill list breakpoints.
 */
@Component({
    selector: 'ngf-shadow-responsive-pill-list',
    templateUrl: './shadow-responsive-pill-list.component.html',
    styleUrls: ['./shadow-responsive-pill-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ShadowResponsivePillListComponent implements AfterViewInit, OnDestroy {

  @Input()
  responsivePills: ResponsivePillDirective[];

  @ViewChild('templatesOutlet', {read: ViewContainerRef})
  templatesOutlet: ViewContainerRef;

  private readonly embeddedViewsSub = new ReplaySubject<EmbeddedViewRef<ResponsivePillContext>[]>();
  readonly embeddedViews$ = this.embeddedViewsSub.asObservable();

  constructor(private cdr: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    const embeddedViews = this.responsivePills.map((responsivePill) => this.createEmbeddedView(responsivePill));
    this.cdr.detectChanges(); // detect changes so embedded views are properly rendered and can be queried for bounding box
    this.embeddedViewsSub.next(embeddedViews);
  }

  private createEmbeddedView(responsivePill: ResponsivePillDirective) {
    return this.templatesOutlet.createEmbeddedView(
      responsivePill.templateRef,
      new ResponsivePillContext({
        collapsed: false,
        shadow: true
      }));
  }

  ngOnDestroy(): void {
    this.embeddedViewsSub.complete();
  }
}
